






import Vue from 'vue'

export default Vue.extend({
  name: 'Block',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
})
